import { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import MandatorySign from "../../Components/MandatorySign";
import { CiCircleAlert } from "react-icons/ci";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ConfirmDeleteCardModal = ({
    account_id,
    show,
    handleClose,
    deleteCard,
    fetchData,
    loadingDelete
}) => {
    const {t} = useLanguage()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
    };

    return (
        <Modal show={show} centered size="sm" onHide={closeModal} className="delete_modal_sm">
            <div className="modal_header">
                <p className="modal_header_title">
                    {t.delete_payment_method}
                </p>
            </div>

            <div className="modal_main_cont">
                <p className="role_warning_text" >
                    {t.billing.delete_card_warning}
                </p>
            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_delete_btn"
                        onClick={deleteCard}
                        disabled={loadingDelete}
                    >
                        {loadingDelete ? <Spinner loading={true} /> : t.delete}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingDelete}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmDeleteCardModal;